"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputValidator = void 0;
const DOM_1 = require("../DOM");
const StringValidator_1 = require("./StringValidator");
const StringValidatorValidationType_1 = require("../../definitions/utils/validator/stringValidator/StringValidatorValidationType");
const ValidatorDNS_1 = require("./ValidatorDNS");
const ElementValidatorUtil_1 = require("./ElementValidatorUtil");
const Notify_1 = require("../Notify");
class InputValidator {
    static validateInput(input, isUpdate, formOptions) {
        const params = ElementValidatorUtil_1.ElementValidatorUtil.getValidationParams(input);
        if (params.regexes) {
            this.validateRegexes(input, params.regexes);
        }
        if (params.customMaxLength) {
            this.validateMaxLength(input, params.customMaxLength);
        }
        if (params.minLength) {
            this.validateMinLength(input, params.minLength);
        }
        if (params.filled) {
            this.validateFilled(input, params.filled);
        }
        if (params.filledOneOf) {
            this.validateOneOfFilled(input, params.filledOneOf, isUpdate);
        }
        if (params.email) {
            this.validateEmail(input, params.email);
        }
        if (params.equalControlName) {
            this.validateEqualControlName(input, params.equalControlName);
        }
        if (params.maxFileSize) {
            this.validateMaxFileSize(input, params.maxFileSize);
        }
        if (params.maxNumber) {
            this.validateMaxNumber(input, params.maxNumber);
        }
        if (params.minNumber) {
            this.validateMinNumber(input, params.minNumber);
        }
        if (params.dnsValidation) {
            this.validateDns(input, formOptions, params.dnsValidation, isUpdate);
        }
        if (params.stringValidation) {
            this.validateStringValidation(input, params.stringValidation);
        }
        if (params.date) {
            this.validateDate(input, params.date);
        }
    }
    static validateDate(element, params) {
        const value = element.value.trim();
        if (value) {
            const valid = StringValidator_1.StringValidator.validateString(value, { name: StringValidatorValidationType_1.StringValidatorValidationType.DATE, meta: null });
            const validFuture = StringValidator_1.StringValidator.validateString(value, { name: StringValidatorValidationType_1.StringValidatorValidationType.DATE_FUTURE, meta: null });
            const problemFuture = DOM_1.DOM.Parser.getDataByNameFromElement('trsFormsDateAfter', DOM_1.DOM.Parser.getHtmlElement('jsTranslations'));
            if (!valid || (params.onlyFuture && !validFuture)) {
                element.dataset.valid = "false";
                ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, (params.onlyFuture && !validFuture) ? problemFuture : params.problem, false);
                return;
            }
        }
        ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, true);
    }
    static validateRegexes(element, regexes) {
        if (regexes) {
            for (let i = 0; i < regexes.length; i++) {
                const value = element.value.trim();
                if (value && !regexes[i].regex.test(value)) {
                    element.dataset.valid = "false";
                    ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, regexes[i].problem, false);
                    return;
                }
                ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, regexes[i].problem, true);
            }
        }
    }
    static validateMaxLength(element, params) {
        if (!StringValidator_1.StringValidator.validateString(element.value, { name: StringValidatorValidationType_1.StringValidatorValidationType.MAX_LENGTH, meta: params.length })) {
            element.dataset.valid = "false";
            ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, false);
            return;
        }
        ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, true);
    }
    static validateMinLength(element, params) {
        if (!StringValidator_1.StringValidator.validateString(element.value, { name: StringValidatorValidationType_1.StringValidatorValidationType.MIN_LENGTH, meta: params.length })) {
            element.dataset.valid = "false";
            ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, false);
            return;
        }
        ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, true);
    }
    static validateFilled(element, params) {
        let valid = element.getAttribute('type') === 'checkbox'
            ? element.checked
            : StringValidator_1.StringValidator.validateString(element.value, { name: StringValidatorValidationType_1.StringValidatorValidationType.REQUIRED, meta: null });
        if (!valid) {
            element.dataset.valid = "false";
        }
        ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, valid);
    }
    static validateOneOfFilled(element, params, isUpdate) {
        let someIsFilled = false;
        for (const inputName of params.inputNames) {
            const currentInput = DOM_1.DOM.Parser.getHtmlInputElementByName(inputName);
            someIsFilled = currentInput.type === 'checkbox'
                ? currentInput.checked
                : StringValidator_1.StringValidator.validateString(currentInput.value, { name: StringValidatorValidationType_1.StringValidatorValidationType.REQUIRED, meta: null });
            if (someIsFilled) {
                break;
            }
        }
        if (!someIsFilled) {
            element.dataset.valid = "false";
            ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, false);
        }
        else {
            ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, true);
        }
        if (!isUpdate) {
            params.inputNames.forEach((inputName) => {
                const currentInput = DOM_1.DOM.Parser.getHtmlInputElementByName(inputName);
                currentInput.dispatchEvent(new Event('update'));
            });
        }
    }
    static validateEmail(element, params) {
        const value = element.value.trim();
        if (value && value.includes(',')) {
            const emails = value.split(",");
            emails.forEach(function (email) {
                const valid = StringValidator_1.StringValidator.validateString(email, { name: StringValidatorValidationType_1.StringValidatorValidationType.EMAIL, meta: null });
                if (!valid || email.length === 0) {
                    element.dataset.valid = "false";
                    ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, false);
                    return;
                }
            });
        }
        else if (value) {
            const valid = StringValidator_1.StringValidator.validateString(value, { name: StringValidatorValidationType_1.StringValidatorValidationType.EMAIL, meta: null });
            if (!valid) {
                element.dataset.valid = "false";
                ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, false);
                return;
            }
        }
        ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, true);
    }
    static validateEqualControlName(element, params) {
        const referenceElement = DOM_1.DOM.Parser.getHtmlInputElementByName(params.name);
        const referenceElementValue = referenceElement.value.trim();
        const elementValue = element.value.trim();
        if (referenceElementValue !== elementValue) {
            element.dataset.valid = "false";
            ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, false);
            return;
        }
        ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, true);
    }
    static validateMaxFileSize(element, params) {
        if (!element.files || typeof element.files[0] === 'undefined') {
            return;
        }
        const size = Array.from(element.files).reduce((acc, value) => acc + value.size, 0);
        if (size > params.maxSize) {
            element.dataset.valid = "false";
            ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, false);
            const jsTranslations = DOM_1.DOM.Parser.getHtmlElement('jsTranslations');
            Notify_1.Notify.Handler.processMessages([{
                    message: DOM_1.DOM.Parser.getDataByNameFromElement('trsFormsMaxFilesize', jsTranslations),
                    type: "warning",
                    closeModal: null,
                    uniqKeys: null,
                    eventId: null
                }]);
            element.value = "";
            element.dispatchEvent(new Event('change'));
            return;
        }
        ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, true);
    }
    static validateMaxNumber(element, params) {
        const value = element.value.trim();
        if (parseInt(value) > params.max) {
            element.dataset.valid = "false";
            ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, false);
        }
        ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, true);
    }
    static validateMinNumber(element, params) {
        const value = element.value.trim();
        if (parseInt(value) < params.min) {
            element.dataset.valid = "false";
            ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, false);
        }
        ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, true);
    }
    static validateDns(element, options, params, isUpdate) {
        const dnsTypeSelect = DOM_1.DOM.Parser.getHtmlInputElementByName(params.typeInputName);
        const dnsType = dnsTypeSelect.value;
        const value = element.value.trim();
        const patternTypes = params.patterns[dnsType];
        if (!patternTypes) {
            return;
        }
        let iterablePatterns;
        if (typeof patternTypes === 'object' && !Array.isArray(patternTypes)) {
            iterablePatterns = Object.entries(patternTypes).map((item) => {
                return { name: item[0], meta: item[1] ?? null };
            });
        }
        else {
            iterablePatterns = patternTypes.map((item) => {
                return { name: item, meta: null };
            });
        }
        for (const input of iterablePatterns) {
            if (!ValidatorDNS_1.ValidatorDNS.validate(value, input, params, element, options.form, isUpdate)) {
                element.dataset.valid = "false";
                ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, false);
                return;
            }
        }
        ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, true);
    }
    static validateStringValidation(element, params) {
        const value = element.value.trim();
        if (!StringValidator_1.StringValidator.validateString(value, { name: params.patternType, meta: null })) {
            element.dataset.valid = "false";
            ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, false);
            return;
        }
        ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, true);
    }
}
exports.InputValidator = InputValidator;
